import logoImg from "../static/logo.jpg";
import noDataImg from "../static/no_data.png";
import noNoticeImg from "../static/no_notice.png";
import avatarImg from "../static/avatar.png";
import spliterLineImg from "../static/spliter-line.png";

const assetsConfig = {
    logo : logoImg,
    noData : noDataImg,
    noNotice : noNoticeImg,
    defaultAvatar: avatarImg,
    spliterLine: spliterLineImg
}

export default assetsConfig;
